import _slicedToArray from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectSpread from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.object.to-string.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue";
var _hoisted_1 = {
  class: "evaluate-module"
};
var _hoisted_2 = {
  key: 0,
  class: "list-loading"
};
var _hoisted_3 = {
  key: 2,
  class: "group-list"
};
var _hoisted_4 = ["id"];
var _hoisted_5 = {
  class: "group-name"
};
var _hoisted_6 = {
  class: "person-standard-list"
};
import { ref, computed, onMounted } from 'vue';
import StudentItem from './components/StudentItem.vue';
import StudentEvaDrawer from './components/StudentEvaDrawer.vue';
import { getPersonals, getEvaUserInfo, checkPermission } from '@/api/evaluate';
import { appAliasEvent } from '@/utils/auth.js';
import { getStore } from '@/util/store';
export default {
  __name: 'index',
  setup: function setup(__props) {
    var _ref = getStore({
        name: 'accessInfo'
      }) || {},
      access_token = _ref.access_token;
    var groupList = ref([]);
    var isLoading = ref(false);
    var visible = ref(false);
    var userInfo = ref(null);
    var isEmpty = computed(function () {
      return !isLoading.value && groupList.value.length === 0;
    });

    // 获取权限
    var permissions = ref(null);
    var handleCheckPermission = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _yield$checkPermissio, data, _permissions$value, classFlag, projectFlag, isCanEvaluate, _t, _t2;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              isLoading.value = true;
              _context.n = 1;
              return checkPermission();
            case 1:
              _yield$checkPermissio = _context.v;
              data = _yield$checkPermissio.data;
              permissions.value = data.data;
              _permissions$value = permissions.value, classFlag = _permissions$value.classFlag, projectFlag = _permissions$value.projectFlag;
              isCanEvaluate = classFlag === 0 && projectFlag === 0;
              _t = isCanEvaluate;
              if (!_t) {
                _context.n = 2;
                break;
              }
              _context.n = 2;
              return initData();
            case 2:
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t2 = _context.v;
              console.log(_t2.message);
            case 4:
              _context.p = 4;
              isLoading.value = false;
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, null, [[0, 3, 4, 5]]);
      }));
      return function handleCheckPermission() {
        return _ref2.apply(this, arguments);
      };
    }();

    // 是否可查看 评选
    var isCanView = computed(function () {
      var _ref3 = permissions.value || {},
        classFlag = _ref3.classFlag,
        projectFlag = _ref3.projectFlag;
      return classFlag === 0 && projectFlag === 0;
    });

    // 无权限提示
    var notPermissionText = function notPermissionText() {
      var _ref4 = permissions.value || {},
        classFlag = _ref4.classFlag,
        projectFlag = _ref4.projectFlag;
      if (classFlag === 1) {
        return '尚未加入班级，无法参与评价';
      }
      if (classFlag === 0 && projectFlag === 1) {
        return '当前年级尚未配置综合素质评价，请联系管理员';
      }
    };

    /**
     * 初始化数据
     */
    var classInfo = ref(null);
    var initData = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var result, _result$data, code, data, _t3;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              isLoading.value = true;
              _context2.n = 1;
              return getEvaUserInfo();
            case 1:
              result = _context2.v;
              _result$data = result.data, code = _result$data.code, data = _result$data.data;
              if (!(code === 0)) {
                _context2.n = 2;
                break;
              }
              classInfo.value = (data === null || data === void 0 ? void 0 : data.currentClass) || {};
              _context2.n = 2;
              return getPersonalsReqeust();
            case 2:
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t3 = _context2.v;
              console.log(_t3.message);
              isLoading.value = false;
            case 4:
              return _context2.a(2);
          }
        }, _callee2, null, [[0, 3]]);
      }));
      return function initData() {
        return _ref5.apply(this, arguments);
      };
    }();
    /**
     * 获取个人列表
     */
    var getPersonalsReqeust = /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var result, _result$data2, code, data, tempData, _t4;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              _context3.n = 1;
              return getPersonals();
            case 1:
              result = _context3.v;
              _result$data2 = result.data, code = _result$data2.code, data = _result$data2.data;
              if (code === 0) {
                tempData = data || [];
                groupList.value = tempData.map(function (item) {
                  var projectId = item.projectId,
                    personalView = item.personalView;
                  var tempPersonals = personalView || [];
                  var personals = tempPersonals.map(function (sItem) {
                    return _objectSpread(_objectSpread({}, sItem), {}, {
                      projectId: projectId
                    });
                  });
                  return _objectSpread(_objectSpread({}, item), {}, {
                    personals: personals,
                    personalView: null
                  });
                });
              }
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t4 = _context3.v;
              console.log(_t4.message);
            case 3:
              _context3.p = 3;
              isLoading.value = false;
              return _context3.f(3);
            case 4:
              return _context3.a(2);
          }
        }, _callee3, null, [[0, 2, 3, 4]]);
      }));
      return function getPersonalsReqeust() {
        return _ref6.apply(this, arguments);
      };
    }();
    /**
     * 本周更多
     * @param {*} item
     */
    var handleWeekMore = /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(item) {
        var projectId, userId, query, appUrl, queryStr, url;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              projectId = item.projectId, userId = item.userId;
              query = {
                type: 'personal',
                projectId: projectId,
                evaluateObjectId: userId,
                currentPeriod: 1
              };
              _context4.n = 1;
              return appAliasEvent('comprehensiveEvaluate');
            case 1:
              appUrl = _context4.v;
              if (appUrl) {
                queryStr = Object.entries(query).map(function (_ref8) {
                  var _ref9 = _slicedToArray(_ref8, 2),
                    key = _ref9[0],
                    value = _ref9[1];
                  return "".concat(key, "=").concat(value);
                }).join('&');
                url = "".concat(appUrl, "?comprehensiveEvaluate=/standard/detail?").concat(queryStr, "&token=").concat(access_token);
                window.open(url);
              }
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }));
      return function handleWeekMore(_x) {
        return _ref7.apply(this, arguments);
      };
    }();
    /**
     * 添加
     * @param {*} item
     */
    var handleAdd = function handleAdd(item) {
      console.log('验收');
      userInfo.value = _objectSpread({}, item);
      visible.value = true;
    };

    /**
     * 监听APP刷新事件
     */
    onMounted(function () {
      handleCheckPermission();
    });
    return function (_ctx, _cache) {
      var _component_Loading = _resolveComponent("Loading");
      var _component_empty = _resolveComponent("empty");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [isLoading.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_Loading), _cache[1] || (_cache[1] = _createElementVNode("span", null, "加载中...", -1))])) : _createCommentVNode("", true), isEmpty.value ? (_openBlock(), _createBlock(_component_empty, {
        key: 1,
        "full-height": "",
        text: notPermissionText()
      }, null, 8, ["text"])) : _createCommentVNode("", true), !isLoading.value && isCanView.value ? (_openBlock(), _createElementBlock("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupList.value, function (item, index) {
        return _openBlock(), _createElementBlock("div", {
          id: "sort-".concat(index),
          key: item.id,
          class: "group-item"
        }, [_createElementVNode("h6", _hoisted_5, _toDisplayString("".concat(index + 1, ".").concat(item.groupName)), 1), _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.personals, function (stuItem) {
          return _openBlock(), _createBlock(StudentItem, {
            key: stuItem.id,
            class: "student-item",
            item: stuItem,
            onWeekMore: handleWeekMore,
            onAdd: handleAdd
          }, null, 8, ["item"]);
        }), 128))])], 8, _hoisted_4);
      }), 128))])) : _createCommentVNode("", true), _createVNode(StudentEvaDrawer, {
        visible: visible.value,
        "onUpdate:visible": _cache[0] || (_cache[0] = function ($event) {
          return visible.value = $event;
        }),
        "stu-item": userInfo.value,
        "class-info": classInfo.value,
        onRefresh: initData
      }, null, 8, ["visible", "stu-item", "class-info"])]);
    };
  }
};